import { LoadingButton } from "@mui/lab";
import {
  Button,
  Checkbox,
  Chip,
  Container,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Paper,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useImportacionesContext } from "../importaciones-context";
import {
  ImportacionProvider,
  useImportacionContext,
} from "./importacion-context";
import { MdArrowBack } from "react-icons/md";

export function ImportacionForm() {
  return (
    <ImportacionProvider>
      <Form />
    </ImportacionProvider>
  );
}

function Form() {
  const params = useParams();
  const navigate = useNavigate();

  const { addImportacion, isAdding, updateImportacion, isUpdating, cancel } =
    useImportacionesContext();

  const { importacion, setImportacion, isEditing } = useImportacionContext();

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!!isEditing) {
        return await updateImportacion({
          importacionId: params.importacion_id,
          importacion,
        });
      } else {
        return await addImportacion({ importacion });
      }
    } catch (error) {
      console.log(error.message);
    }
  }

  return (
    <Container maxWidth="sm" className="animate__animated animate__fadeIn">
      <Paper
        component="form"
        onSubmit={handleSubmit}
        onReset={cancel}
        sx={{ padding: 2 }}
        variant="outlined"
      >
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <Tooltip title="Atrás">
                  <IconButton
                    onClick={() => navigate("../..", { replace: true })}
                  >
                    <MdArrowBack />
                  </IconButton>
                </Tooltip>

                <Typography variant="h6">
                  {`${!!isEditing ? "Editar" : "Agregar"} importación`}
                </Typography>
              </Stack>

              {!!isEditing && (
                <Chip
                  label={
                    !!importacion.importacion_verificada
                      ? "Verificado"
                      : "Pendiente"
                  }
                  color={
                    !!importacion.importacion_verificada ? "success" : "warning"
                  }
                  size="small"
                  variant="outlined"
                />
              )}
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <TextField
              type="text"
              label="Detalles"
              value={importacion.importacion_detalles}
              onChange={(e) =>
                setImportacion((importacion) => ({
                  ...importacion,
                  importacion_detalles: e.target.value,
                }))
              }
              size="small"
              fullWidth
              required
              disabled={!!importacion.importacion_verificada}
            />
          </Grid>

          <Grid item xs={12}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={importacion.importacion_principal}
                    onChange={(e) =>
                      setImportacion((importacion) => ({
                        ...importacion,
                        importacion_principal: e.target.checked,
                      }))
                    }
                  />
                }
                label="¿Es una importación principal?"
                disabled={!!importacion.importacion_verificada}
              />
            </FormGroup>
          </Grid>

          {!importacion.importacion_verificada && (
            <Grid item xs={12}>
              <Stack direction="row" justifyContent="end" spacing={1}>
                <LoadingButton
                  type="submit"
                  variant="contained"
                  size="small"
                  color={!!isEditing ? "warning" : "success"}
                  loading={!!isUpdating || !!isAdding}
                >
                  {!!isEditing ? "Actualizar" : "Agregar"}
                </LoadingButton>

                <Button
                  type="reset"
                  variant="outlined"
                  size="small"
                  color="inherit"
                  disabled={!!isUpdating || !!isAdding}
                >
                  Cancelar
                </Button>
              </Stack>
            </Grid>
          )}
        </Grid>
      </Paper>
    </Container>
  );
}
